import { jsx } from 'react/jsx-runtime';

const Icon = ({ ...otherProps }) => (jsx("i", { ...otherProps }));

export { Icon };
//# sourceMappingURL=Icon.js.map
